import { ReactNode } from "react";
import styled from "styled-components";
import {
  Arrow as RadixArrow,
  Content as RadixContent,
  TooltipContentProps,
  TooltipProps,
} from "@radix-ui/react-tooltip";
import { zIndex } from "../../styles/constants";
import { shade0, shade900 } from "../../styles/tokens";

// TEXT

// STYLES
export const Content = styled(RadixContent)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.125rem 0.5rem;
  background: ${shade0};
  color: ${shade900};
  max-width: 18rem;
  z-index: ${zIndex.dropdown};
`;

// Gives long tooltip text a width to wrap against, so it doesn't overflow.
// Must stay a separate element, not a rule like `Content > * { width: 100% }`
// — that would also resize the arrow, which needs its real size to point at
// the right spot.
export const TipText = styled.div`
  width: 100%;
  overflow-wrap: break-word;
`;

export const Arrow = styled(RadixArrow)`
  width: 0.8rem;
  height: 0.5rem;
  fill: ${shade0};
`;

// DATA

// TYPES
export interface TooltipCompProps extends Omit<TooltipProps, "children"> {
  /**
   * The text or element to be displayed in the tooltip
   */
  tip: string | ReactNode;
  /**
   * The text or element that triggers the tooltip
   */
  children: ReactNode;
}

export type Props = TooltipCompProps & TooltipContentProps;

// CONSTANTS

// FUNCTIONS

// ASSETS
